import React from "react"
const AlternatingHeader = ({
  activeContent,
  url,
  update,
  urlTextToDisplay,
}) => {
  return (
    <div className={`container-fluid px-0 `}>
      <a
        target={`${activeContent ? "_blank" : ""}`}
        href={`${activeContent ? url : "mailto:support@sparkle.ng"}`}
        className={`banner-link px-1`}
        rel="noreferrer"
      >
        {activeContent ? (
          <span className="mr-3">{update}</span>
        ) : (
          <span className="warning-content">
            Sparkle will <b>NEVER</b> on any occasion ask for your PIN, OTP,
            Card information or Login details. Do not share your personal
            banking information with anyone online or in person. If you’re ever
            in doubt, send an email to{" "}
          </span>
        )}

        <span>{activeContent ? urlTextToDisplay : "Support@sparkle.ng"}</span>
      </a>
    </div>
  )
}
export default AlternatingHeader
